<template>
  <div class="wimshurst-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>电荷倍增与高压火花</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Discs (Represented as rotating circles) -->
          <g transform="translate(150, 120)">
             <circle r="80" fill="none" stroke="#444" stroke-width="2" />
             <g :transform="`rotate(${angle})`">
                <rect v-for="i in 12" :key="i" :x="70" y="-5" width="20" height="10" fill="#aaa" :transform="`rotate(${i*30})`" />
             </g>
             <circle r="70" fill="none" stroke="#333" stroke-width="1" stroke-dasharray="4" />
             <g :transform="`rotate(${-angle})`">
                <rect v-for="i in 12" :key="'b'+i" :x="60" y="-5" width="20" height="10" fill="#ffd700" :transform="`rotate(${i*30})`" />
             </g>
          </g>

          <!-- Leyden Jars (Capacitors) -->
          <rect x="250" y="160" width="30" height="60" fill="#1e272e" rx="2" />
          <rect x="300" y="160" width="30" height="60" fill="#1e272e" rx="2" />
          <text x="260" y="235" fill="#888" font-size="8">莱顿瓶 (电容)</text>

          <!-- Spark Gap -->
          <g transform="translate(320, 100)">
             <circle cx="-30" cy="0" r="10" fill="#aaa" />
             <circle cx="30" cy="0" r="10" fill="#aaa" />
             <!-- Spark -->
             <path v-if="sparking" :d="sparkPath" fill="none" stroke="#fff" stroke-width="2">
                <animate attributeName="stroke" values="#fff;#00d2ff;#fff" dur="0.05s" repeatCount="indefinite" />
             </path>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电压 Voltage: {{ (charge * 50).toFixed(0) }} kV</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @mousedown="isRotating = true" @mouseup="isRotating = false">摇动摇杆 (起电)</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>维姆胡斯起电机是一种经典的静电感应发电机。它通过两个反向旋转的绝缘盘上的金属片，利用**静电感应**原理不断倍增极板间的微小电荷。电荷被收集到莱顿瓶（早期电容器）中积累，最终在放电叉间产生数万伏的高压火花。这是19世纪研究电学的重要工具。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WimshurstMachineViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 0,
      isRotating: false,
      charge: 0,
      sparking: false,
      timer: null
    }
  },
  computed: {
    sparkPath() {
       let d = "M -20,0 ";
       for (let i = 1; i < 5; i++) {
          d += `L ${-20 + i*10} ${(Math.random()-0.5)*15} `;
       }
       return d + " L 20,0";
    }
  },
  methods: {
    update() {
      if (this.isRotating) {
         this.angle += 5;
         this.charge = Math.min(100, this.charge + 0.2);
         if (this.charge > 95 && Math.random() > 0.8) {
            this.sparking = true;
            this.charge = 10; // Discharge
            setTimeout(() => { this.sparking = false; }, 100);
         }
      } else {
         this.charge = Math.max(0, this.charge - 0.05);
      }
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.wimshurst-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
